(self["webpackChunk"] = self["webpackChunk"] || []).push([[6621],{

/***/ 71552:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(25074);module.exports = "../../app/cells/components/modals/planner_modal/show.erb";

/***/ }),

/***/ 79128:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/planner_modal_cell.rb";

/***/ }),

/***/ 74670:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/questions_review_suggestion_modal/show.erb";

/***/ }),

/***/ 15189:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/questions_review_suggestion_modal_cell.rb";

/***/ }),

/***/ 92267:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(99166);module.exports = "../../app/cells/components/modals/weekly_activity_modal/show.erb";

/***/ }),

/***/ 47935:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/weekly_activity_modal_cell.rb";

/***/ }),

/***/ 96484:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(99166);module.exports = "../../app/cells/components/modals/weekly_activity_modal/statistics_container.erb";

/***/ }),

/***/ 61313:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(99166);module.exports = "../../app/cells/components/modals/weekly_activity_modal/statistics_content.erb";

/***/ }),

/***/ 47165:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(99166);module.exports = "../../app/cells/components/modals/weekly_activity_modal/thermometer.erb";

/***/ }),

/***/ 38972:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(82001);module.exports = "../../app/cells/components/percent_bar/show.erb";

/***/ }),

/***/ 64239:
/***/ ((module) => {

module.exports = "../../app/cells/components/percent_bar_cell.rb";

/***/ }),

/***/ 48933:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(77399);module.exports = "../../app/cells/pages/questions/challenge_feedback/show.erb";

/***/ }),

/***/ 96983:
/***/ ((module) => {

module.exports = "../../app/cells/pages/questions/challenge_feedback_cell.rb";

/***/ }),

/***/ 46137:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(86121);module.exports = "../../app/cells/pages/questions/onboarding_modal/show.erb";

/***/ }),

/***/ 45471:
/***/ ((module) => {

module.exports = "../../app/cells/pages/questions/onboarding_modal_cell.rb";

/***/ }),

/***/ 29998:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(86121);module.exports = "../../app/cells/pages/questions/onboarding_modal/question_challange.erb";

/***/ }),

/***/ 8830:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(86121);module.exports = "../../app/cells/pages/questions/onboarding_modal/question_tip.erb";

/***/ }),

/***/ 40707:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(86121);module.exports = "../../app/cells/pages/questions/onboarding_modal/welcome.erb";

/***/ }),

/***/ 93808:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(55707);module.exports = "../../app/cells/pages/questions/resource_limit_counter/show.erb";

/***/ }),

/***/ 33007:
/***/ ((module) => {

module.exports = "../../app/cells/pages/questions/resource_limit_counter_cell.rb";

/***/ }),

/***/ 84880:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32861);



/***/ }),

/***/ 54764:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony export default */
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59565);
/* harmony import */ var utils_stimulus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40225);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91207);



class FreemiumTrainerModal extends utils_stimulus__WEBPACK_IMPORTED_MODULE_1__/* .Controller */ .Q {
    get isStandardType() {
        return this.modalTarget.dataset.type === 'standard';
    }
    get isInviteType() {
        return this.modalTarget.dataset.type === 'invite';
    }
    connect() {
        this.on('openFreemiumTrainerModal', this.openModal.bind(this));
        if (this.hasFloatingButtonTarget) {
            window.jQuery(document).scroll(this.showFloatingButtonAfterScroll.bind(this));
        }
        if (window.location.href.includes('questoes')) {
            (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .trackViewFreemiumTrainerEvent */ .r)('floating button', {
                invite: this.isInviteType
            });
        }
    }
    showFloatingButtonAfterScroll() {
        if (!this.hasFloatingButtonTarget || this.isModalOpen) {
            return;
        }
        if (window.scrollY > 300) {
            this.showFloatingButton();
        } else {
            this.hideFloatingButton();
        }
    }
    handleMinimizeButtonClick() {
        this.closeModal();
        this.showFloatingButton();
    }
    handleCloseButtonClick() {
        this.closeModal();
        this.removeFloatingButton();
    }
    handleFloatingButtonClick() {
        this.openModal();
    }
    handlePracticeButtonClick(e) {
        const { link } = e.currentTarget.dataset;
        window.location.href = link;
    }
    openModal() {
        this.isModalOpen = true;
        this.hideFloatingButton();
        this.trigger('freemium-trainer-filter-banner->close');
        this.trigger('freemium-trainer-panel->notifyNotificationOpened');
        if (this.hasFloatingButtonTarget) {
            this.floatingButtonTarget.classList.remove('q-freemium-trainer-floating-button--notification');
        }
        if (this.isStandardType) {
            this.fetchModalContent();
        }
        this.modalOverlayTarget.classList.add('q-freemium-trainer-overlay--show');
        this.modalTarget.classList.add('q-freemium-trainer--show');
    }
    closeModal() {
        this.isModalOpen = false;
        this.modalOverlayTarget.classList.remove('q-freemium-trainer-overlay--show');
        this.modalTarget.classList.remove('q-freemium-trainer--show');
    }
    showFloatingButton() {
        if (!this.hasFloatingButtonTarget || this.isModalOpen) {
            return;
        }
        window.jQuery(this.floatingButtonTarget).fadeIn();
    }
    hideFloatingButton() {
        if (!this.hasFloatingButtonTarget) {
            return;
        }
        window.jQuery(this.floatingButtonTarget).fadeOut();
    }
    removeFloatingButton() {
        if (!this.hasFloatingButtonTarget) {
            return;
        }
        this.floatingButtonTarget.remove();
    }
    fetchModalContent() {
        this.loadingTarget.classList.add('loading-container--show');
        Thor.CoachFreemium.show({
            userId: currentUser.id
        }, {}).then((response)=>{
            this.disciplineTypeTarget.textContent = this.getDisciplineTypeText(response.performance_type);
            this.disciplineNameTarget.textContent = response.discipline.name;
            this.disciplineSolvedTarget.textContent = response.discipline.solved;
            this.disciplinePercentageTarget.textContent = response.discipline.correct_percentage + '%';
            this.disciplinePracticeLinkTarget.setAttribute('data-link', response.discipline.practice_link);
            this.subjectTypeTarget.textContent = this.getSubjectTypeText(response.performance_type);
            this.subjectNameTarget.textContent = response.subject.name;
            this.subjectSolvedTarget.textContent = response.subject.solved;
            this.subjectPercentageTarget.textContent = response.subject.correct_percentage + '%';
            this.subjectPracticeLinkTarget.setAttribute('data-link', response.subject.practice_link);
            this.firstSectionTitleTarget.textContent = this.getSectionTitle(response.performance_type);
            this.firstSectionPopupTarget.setAttribute('title', this.getSectionPopup(response.performance_type));
            this.secondSectionTitleTarget.textContent = this.getSectionTitle(response.blured_performance_types[0]);
            this.secondSectionPopupTarget.setAttribute('title', this.getSectionPopup(response.blured_performance_types[0]));
            this.thirdSectionTitleTarget.textContent = this.getSectionTitle(response.blured_performance_types[1]);
            this.thirdSectionPopupTarget.setAttribute('title', this.getSectionPopup(response.blured_performance_types[1]));
        }).catch((error)=>{
            this.closeModal();
            Rollbar.error('[front] Falha ao exibir o Freemium do Treinador.', error);
            toastr.error('Ocorreu um erro ao carregar os dados do Treinador, tente novamente mais tarde.');
        }).finally(()=>{
            this.loadingTarget.classList.remove('loading-container--show');
        });
    }
    getSectionTitle(type) {
        const typeMap = {
            weak: 'Seus pontos Fracos',
            critical: 'Seus pontos Críticos',
            strong: 'Seus pontos Fortes'
        };
        return typeMap[type];
    }
    getSectionPopup(type) {
        const typeMap = {
            weak: 'São considerados <strong>pontos fracos</strong> as disciplinas ou assuntos cujo seu desempenho ficou <strong>entre 50% e 75%</strong>',
            critical: 'São considerados <strong>pontos críticos</strong> as disciplinas ou assuntos cujo seu desempenho foi <strong>inferior a 50%</strong>',
            strong: 'São considerados <strong>pontos fortes</strong> as disciplinas ou assuntos cujo seu desempenho foi <strong>superior a 75%</strong>'
        };
        return typeMap[type];
    }
    getDisciplineTypeText(type) {
        const typeMap = {
            weak: 'DISCIPLINA MAIS FRACA',
            critical: 'DISCIPLINA MAIS CRÍTICA',
            strong: 'DISCIPLINA MAIS FORTE'
        };
        return typeMap[type];
    }
    getSubjectTypeText(type) {
        const typeMap = {
            weak: 'ASSUNTO MAIS FRACO',
            critical: 'ASSUNTO MAIS CRÍTICO',
            strong: 'ASSUNTO A MELHORAR'
        };
        return typeMap[type];
    }
    constructor(...args){
        super(...args);
        this.isModalOpen = false;
    }
}
FreemiumTrainerModal.targets = [
    'modal',
    'modalOverlay',
    'floatingButton',
    'loading',
    'disciplineType',
    'disciplineName',
    'disciplineSolved',
    'disciplinePercentage',
    'disciplinePracticeLink',
    'subjectType',
    'subjectName',
    'subjectSolved',
    'subjectPercentage',
    'subjectPracticeLink',
    'firstSectionTitle',
    'secondSectionTitle',
    'thirdSectionTitle',
    'firstSectionPopup',
    'secondSectionPopup',
    'thirdSectionPopup'
];

(self || window).FreemiumTrainerApplication = (self || window).FreemiumTrainerApplication || utils_stimulus__WEBPACK_IMPORTED_MODULE_1__/* .Application.start */ .M.start();
(self || window).FreemiumTrainerApplication.register('freemium-trainer-modal', FreemiumTrainerModal);


/***/ }),

/***/ 91207:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": () => (/* binding */ trackViewFreemiumTrainerEvent)
/* harmony export */ });
const trackViewFreemiumTrainerEvent = ()=>{
    const localStorageKey = `freemiumTrainerViewed.${window.currentUser.id}`;
    const currentDay = new Date().getDate();
    const freemiumTrainerViewedDay = Number(localStorage.getItem(localStorageKey));
    if (currentDay === freemiumTrainerViewedDay) {
        return;
    }
    localStorage.setItem(localStorageKey, currentDay);
};


/***/ }),

/***/ 24363:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ AccountLimitFreeModal)
/* harmony export */ });
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17335);
/* harmony import */ var utils_countdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56392);


class AccountLimitFreeModal {
    countdownV1Animation() {
        const fullTime = 10;
        const $circle = window.jQuery('#out-circle');
        const $counterText = window.jQuery('#counter-text');
        $counterText.text(fullTime);
        let remainingTime = fullTime;
        const circumference = 2 * Math.PI * $circle.attr('r');
        $circle.css({
            'stroke-dasharray': circumference,
            'stroke-dashoffset': 0,
            transform: 'rotate(-90deg)',
            'transform-origin': '50% 50%'
        });
        setTimeout(()=>{
            const interval = setInterval(function() {
                remainingTime--;
                $counterText.text(remainingTime);
                const dashoffset = circumference * ((fullTime - remainingTime) / fullTime) * 1.5;
                $circle.css('stroke-dashoffset', dashoffset);
                const adjustedDashoffset = Math.min(dashoffset, circumference);
                $circle.css('stroke-dashoffset', adjustedDashoffset);
                if (remainingTime <= 0) {
                    clearInterval(interval);
                }
            }, 80);
        }, 1000);
    }
    countdownV2Animation() {
        const fullTime = 24 * 60 * 60;
        const now = new Date();
        const secondsSinceMidnight = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
        const remainingTime = fullTime - secondsSinceMidnight;
        const $circle = window.jQuery('#out-circle');
        const circumference = 2 * Math.PI * $circle.attr('r');
        const initialOffset = circumference * (secondsSinceMidnight / fullTime);
        $circle.css({
            'stroke-dasharray': circumference,
            'stroke-dashoffset': initialOffset,
            transform: 'rotate(-90deg)',
            'transform-origin': '50% 50%'
        });
        setTimeout(()=>{
            let currentRemainingTime = remainingTime;
            const interval = setInterval(function() {
                currentRemainingTime--;
                const dashoffset = circumference * ((fullTime - currentRemainingTime) / fullTime);
                $circle.css('stroke-dashoffset', dashoffset);
                if (currentRemainingTime <= 0) {
                    clearInterval(interval);
                }
            }, 1000);
        });
    }
    showTimeLeft() {
        (0,utils_countdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            selector: '.js-account-limit-questions-modal .limit-countdown',
            template: '%H:%M:%S'
        });
        (0,utils_countdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            selector: '.js-account-limit-questions-modal .subtitle-limit-countdown',
            template: '%H:%M:%S'
        });
    }
    selectVersion() {
        var _gon_flags;
        const modalLimitation = (_gon_flags = gon.flags) == null ? void 0 : _gon_flags.modal_limitation;
        if (modalLimitation) {
            if (modalLimitation.showV2) {
                this.countdownV2Animation();
            } else {
                this.countdownV1Animation();
            }
        }
    }
    load() {
        this.showTimeLeft();
        this.selectVersion();
    }
}



/***/ }),

/***/ 47413:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ modals_continue_modal)
});

// EXTERNAL MODULE: ./components/modals/continue_modal/index.scss
var continue_modal = __webpack_require__(87838);
// EXTERNAL MODULE: ./components/percent_bar/index.erb
var percent_bar = __webpack_require__(38972);
// EXTERNAL MODULE: ./components/percent_bar/index.rb
var components_percent_bar = __webpack_require__(64239);
;// CONCATENATED MODULE: ./components/percent_bar/index.js



;// CONCATENATED MODULE: ./components/modals/continue_modal/index.js


function HideButtonContinueModalEvent() {
    window.jQuery('#js-hide-continue-modal').on('click', function(e) {
        e.preventDefault();
        if (!localStorage) {
            return;
        }
        localStorage.setItem('continueModalHide', true);
        window.jQuery('#continue-modal-dont-show').prop('checked', false);
        window.UserTracker.emit('event', {
            eventName: 'modal continue occulted'
        });
    });
    window.jQuery('#js-continue-modal').on('shown.bs.modal', function() {
        window.UserTracker.emit('event', {
            eventName: 'modal continue viewed'
        });
    });
    window.jQuery('.q-suggestion-name').on('click', function() {
        window.UserTracker.emit('event', {
            eventName: 'modal continue clicked',
            data: {
                suggestion: window.jQuery(this).data('optionType')
            }
        });
    });
}
/* harmony default export */ const modals_continue_modal = (HideButtonContinueModalEvent);


/***/ }),

/***/ 77322:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ ForumModal)
/* harmony export */ });
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53396);
/* harmony import */ var images_modals_man_computer_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42122);


class ForumModal {
    bind() {
        this.$postBtn.on('click', ()=>{
            Turbolinks.visit(this.playgroundUrl);
        });
    }
    constructor(context){
        this.$context = window.jQuery(context);
        this.$postBtn = window.jQuery('.js-post-btn', this.$context);
        this.playgroundUrl = this.$context.data('playgroundUrl');
        this.bind();
    }
}



/***/ }),

/***/ 57912:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ PlannerModal)
/* harmony export */ });
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71552);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79128);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25074);
/* harmony import */ var _images_illustration_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83028);




class PlannerModal {
    handleChange() {
        const isChecked = this.$checkBox.prop('checked');
        localStorage.setItem('plannerModalDisabled', !isChecked);
    }
    bind() {
        this.$checkBox.on('change', this.handleChange.bind(this));
    }
    constructor(){
        this.$checkBox = window.jQuery('#js-planner-modal-checkbox');
        this.bind();
    }
}



/***/ }),

/***/ 32045:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ QuestionsReviewSuggestionModal)
/* harmony export */ });
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74670);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15189);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7120);
/* harmony import */ var images_questions_review_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96559);




class QuestionsReviewSuggestionModal {
    bind() {
        this.$closeBtn.click(()=>this.$context.animate({
                bottom: -157
            }, 'slow'));
    }
    constructor(){
        this.$context = window.jQuery('#js-questions-review-suggestion-modal');
        this.$closeBtn = window.jQuery('.js-close-btn', this.$context);
        this.bind();
        this.$context.animate({
            bottom: 0
        }, 'slow');
    }
}



/***/ }),

/***/ 56782:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ WeeklyActivityModal)
/* harmony export */ });
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47935);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92267);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _thermometer_erb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47165);
/* harmony import */ var _thermometer_erb__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_thermometer_erb__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _statistics_container_erb__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96484);
/* harmony import */ var _statistics_container_erb__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_statistics_container_erb__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _statistics_content_erb__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61313);
/* harmony import */ var _statistics_content_erb__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_statistics_content_erb__WEBPACK_IMPORTED_MODULE_4__);





class WeeklyActivityModal {
    loadPerformance() {
        var _performanceInfo_data;
        const performanceInfo = window.jQuery('#user-activity-statistics').data('user-performance');
        const studyingTime = performanceInfo == null ? void 0 : (_performanceInfo_data = performanceInfo.data) == null ? void 0 : _performanceInfo_data.length;
        const studyingTimeContainer = window.jQuery('#actvity-study-time');
        studyingTimeContainer.append(`<p><span>${studyingTime}</span> dias estudando</p>`);
        const hitsContainer = window.jQuery('#actvity-hit-performance');
        const missesContainer = window.jQuery('#actvity-miss-performance');
        const hitsCount = performanceInfo == null ? void 0 : performanceInfo.hit;
        const missesCount = performanceInfo == null ? void 0 : performanceInfo.miss;
        hitsContainer.append(`${hitsCount}`);
        missesContainer.append(`${missesCount}`);
    }
    showFirstStep() {
        this.thermometherModalBody.show();
        this.statisticsModalBody.hide();
        this.thermometherModalFooter.show();
        this.statisticsModalFooter.hide();
    }
    showSecondStep() {
        this.thermometherModalBody.hide();
        this.statisticsModalBody.show();
        this.thermometherModalFooter.hide();
        this.statisticsModalFooter.show();
    }
    bind() {
        this.previousModalBtn.on('click', ()=>this.showFirstStep());
        this.nextModalBtn.on('click', ()=>this.showSecondStep());
        if (this.showPerformance) {
            this.loadPerformance();
        }
    }
    constructor(){
        this.container = window.jQuery('#js-questions-weekly-activity-modal');
        this.showPerformance = this.container.data('show-performance');
        this.thermometherModalBody = window.jQuery('#weekly-activity-modal-first-body');
        this.statisticsModalBody = window.jQuery('#weekly-activity-modal-second-body');
        this.thermometherModalFooter = window.jQuery('#weekly-activity-modal-first-footer');
        this.statisticsModalFooter = window.jQuery('#weekly-activity-modal-second-footer');
        this.nextModalBtn = window.jQuery('#weekly-activity-modal-first');
        this.previousModalBtn = window.jQuery('#weekly-activity-modal-second');
        this.bind();
    }
}



/***/ }),

/***/ 66593:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const rules = {
    utils: {
        bodyData () {
            return window.jQuery('body').data();
        }
    },
    account () {
        return this.utils.bodyData().isUserSignedIn;
    },
    confirmed_account () {
        return this.utils.bodyData().isUserEmailConfirmed;
    },
    trial () {
        return this.utils.bodyData().isUserFeatureTrial;
    },
    trialAndStandard () {
        return this.trial() && !this.subscription();
    },
    subscription () {
        return this.utils.bodyData().isUserSubscribed;
    },
    premium () {
        return this.utils.bodyData().isUserPremium || this.premiumPlus() || this.black() || this.unlimited() || this.digitalUnlimited() || this.judicial() || this.judicialUnlimited() || this.unlimitedQc(); // FIXME MAYKE PLEASE
    },
    premiumPlus () {
        return this.utils.bodyData().isUserPremiumPlus;
    },
    black () {
        return this.utils.bodyData().isUserBlack;
    },
    unlimited () {
        return this.utils.bodyData().isUserUnlimited;
    },
    digitalUnlimited () {
        return this.utils.bodyData().isUserDigitalUnlimited;
    },
    judicial () {
        return this.utils.bodyData().isUserJudicial;
    },
    judicialUnlimited () {
        return this.utils.bodyData().isUserJudicialUnlimited;
    },
    unlimitedQc () {
        return this.utils.bodyData().isUserUnlimitedQc;
    },
    commented_feedback_enabled () {
        return this.subscription() || gon.flags.question_belt_limits.commented_feedback_limit > 0;
    }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (rules);


/***/ }),

/***/ 40225:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ Controller),
/* harmony export */   "M": () => (/* binding */ Application)
/* harmony export */ });
/* harmony import */ var stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56938);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82941);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pubsub_js__WEBPACK_IMPORTED_MODULE_1__);


// Adding trigger and on to controllers
(pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().immediateExceptions) = RAILS_ENV === 'development';
class Controller extends stimulus__WEBPACK_IMPORTED_MODULE_0__/* .Controller */ .Qr {
    trigger(identifier, params) {
        const parts = identifier.split('->');
        if (parts.length < 2) throw new Error('Event identifier is in an incorrect format!');
        const controller = parts[0];
        const action = parts[1];
        pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().publish(`stimulus.${controller}.${action}`, params);
    }
    on(action, callback) {
        const controller = this.identifier;
        pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().subscribe(`stimulus.${controller}.${action}`, (eventName, params)=>callback(params));
    }
    disconnect() {
        const controller = this.identifier;
        pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().unsubscribe(`stimulus.${controller}`);
        return super.disconnect();
    }
    constructor(){
        super(...arguments);
    }
}
class Application extends stimulus__WEBPACK_IMPORTED_MODULE_0__/* .Application */ .Mx {
    register(identifier, controllerConstructor) {
        if (this.controllers.indexOf(controllerConstructor) === -1) return super.register(identifier, controllerConstructor);
        else console.warning(`Controller "${identifier}" already registered!`);
    }
    constructor(){
        super(...arguments);
    }
}



/***/ }),

/***/ 56938:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mx": () => (/* reexport safe */ _stimulus_core__WEBPACK_IMPORTED_MODULE_0__.Mx),
/* harmony export */   "Qr": () => (/* reexport safe */ _stimulus_core__WEBPACK_IMPORTED_MODULE_0__.Qr)
/* harmony export */ });
/* harmony import */ var _stimulus_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47879);



/***/ }),

/***/ 83028:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/illustration-2a5a7ffda686afc0be9c.svg";

/***/ }),

/***/ 42122:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/man-computer-9031b3bbf282af2cf805.svg";

/***/ }),

/***/ 96559:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/review-07c32c41b03034b2f499.svg";

/***/ }),

/***/ 21636:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/rocket_up-47d53093e373372559d0.png";

/***/ }),

/***/ 62515:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/studing_boy-0f4afd61b792cc0f06f9.png";

/***/ }),

/***/ 20971:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/avatar-46186ff32d34e4678886.png";

/***/ })

}]);